import React, { useEffect, useState } from "react";

/**
 * Banner discreto sotto la mini-anteprima che diventa visibile durante il
 * sync di layout/colore e per 2.5s pulsa con un check verde, poi resta come
 * label discreta. Comunica chiaramente che la scelta è già attiva su tutti i
 * formati senza richiedere salvataggi manuali.
 */
export default function SyncedBanner({ syncing, pulseKey }) {
  const [highlight, setHighlight] = useState(false);
  useEffect(() => {
    if (!pulseKey) return;
    setHighlight(true);
    const t = setTimeout(() => setHighlight(false), 2500);
    return () => clearTimeout(t);
  }, [pulseKey]);

  return (
    <div
      className={`mt-2.5 flex items-center gap-2 text-[10.5px] font-medium rounded-md px-2.5 py-1.5 border transition-all duration-500 ${
        syncing
          ? "bg-[#F1F4ED] border-[#D5DDC5] text-[#5C6A48]"
          : highlight
            ? "bg-[#E8F0E0] border-[#B5C4A6] text-[#3F4F35] shadow-[0_0_0_3px_rgba(124,139,110,0.15)]"
            : "bg-[#FAFAF7] border-[#EAE7DF] text-[#7C8B6E]"
      }`}
      data-testid="style-synced-banner"
    >
      {syncing ? (
        <span className="inline-block w-2 h-2 rounded-full bg-[#7C8B6E] animate-pulse" />
      ) : (
        <span className="inline-flex items-center justify-center w-3.5 h-3.5 rounded-full bg-[#7C8B6E] text-white text-[8px] font-bold leading-none">✓</span>
      )}
      <span className="leading-snug">
        {syncing
          ? "Sto sincronizzando lo stile…"
          : highlight
            ? "Stile salvato per questo annuncio · si applica a video e download"
            : "Stile sincronizzato · si applica a tutti i formati esportati"}
      </span>
    </div>
  );
}
